<p-drawer
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  position="right"
  styleClass="model-properties-drawer"
  [style]="{ width: '900px' }"
  [modal]="true"
  (onHide)="close()">

  <ng-template pTemplate="header">
    <div class="drawer-header">
      <i class="pi pi-cog"></i>
      <h2 i18n="@@modelProperties.header">Edit version properties</h2>
      <small class="drawer-subheader">
        {{ modelName() }}@if (versionName()) { · {{ versionName() }} }
      </small>
    </div>
  </ng-template>

  <div class="drawer-content">
    <section class="drawer-section">
      <h3 class="section-title" i18n="@@modelProperties.section.flags">Flags</h3>
      <label class="switch-row">
        <p-toggleSwitch
          [ngModel]="isRecommended()"
          (ngModelChange)="onRecommendedChange($event)">
        </p-toggleSwitch>
        <span class="switch-label" i18n="@@modelProperties.flag.recommended">Recommended</span>
        <small class="switch-hint" i18n="@@modelProperties.flag.recommended.hint">
          Marks this version as recommended for the platform — surfaced in catalogues and pickers.
        </small>
      </label>
    </section>

    <section class="drawer-section">
      <h3 class="section-title" i18n="@@modelProperties.section.pricing">Pricing</h3>

      @if (isLlm()) {
        <div class="pricing-grid">
          <div class="field">
            <label i18n="@@modelProperties.price.inputTokens">Input ($ / M tokens)</label>
            <p-inputNumber
              [ngModel]="inputPricePerMTokens()"
              (ngModelChange)="inputPricePerMTokens.set($event)"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="6"
              [min]="0"
              [showButtons]="true"
              [step]="0.01"
              [disabled]="isSaving()"
              i18n-placeholder="@@modelProperties.price.placeholder"
              placeholder="0.00">
            </p-inputNumber>
          </div>
          <div class="field">
            <label i18n="@@modelProperties.price.outputTokens">Output ($ / M tokens)</label>
            <p-inputNumber
              [ngModel]="outputPricePerMTokens()"
              (ngModelChange)="outputPricePerMTokens.set($event)"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="6"
              [min]="0"
              [showButtons]="true"
              [step]="0.01"
              [disabled]="isSaving()"
              i18n-placeholder="@@modelProperties.price.placeholder"
              placeholder="0.00">
            </p-inputNumber>
          </div>
          <div class="field">
            <label i18n="@@modelProperties.price.inputCached">Input cached ($ / M tokens)</label>
            <p-inputNumber
              [ngModel]="inputCachedPricePerMTokens()"
              (ngModelChange)="inputCachedPricePerMTokens.set($event)"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="6"
              [min]="0"
              [showButtons]="true"
              [step]="0.01"
              [disabled]="isSaving()"
              i18n-placeholder="@@modelProperties.price.placeholder"
              placeholder="0.00">
            </p-inputNumber>
          </div>
          <div class="field">
            <label i18n="@@modelProperties.price.cacheWrite">Cache write ($ / M tokens)</label>
            <p-inputNumber
              [ngModel]="inputCacheWritePricePerMTokens()"
              (ngModelChange)="inputCacheWritePricePerMTokens.set($event)"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="6"
              [min]="0"
              [showButtons]="true"
              [step]="0.01"
              [disabled]="isSaving()"
              i18n-placeholder="@@modelProperties.price.placeholder"
              placeholder="0.00">
            </p-inputNumber>
          </div>
        </div>
      } @else if (isTts()) {
        <div class="pricing-grid">
          <div class="field">
            <label i18n="@@modelProperties.price.characters">$ / M characters</label>
            <p-inputNumber
              [ngModel]="pricePerMCharacters()"
              (ngModelChange)="pricePerMCharacters.set($event)"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="6"
              [min]="0"
              [showButtons]="true"
              [step]="0.01"
              [disabled]="isSaving()"
              i18n-placeholder="@@modelProperties.price.placeholder"
              placeholder="0.00">
            </p-inputNumber>
          </div>
        </div>
      } @else if (isStt()) {
        <div class="pricing-grid">
          <div class="field">
            <label i18n="@@modelProperties.price.minute">$ / minute</label>
            <p-inputNumber
              [ngModel]="pricePerMinute()"
              (ngModelChange)="pricePerMinute.set($event)"
              mode="decimal"
              [minFractionDigits]="4"
              [maxFractionDigits]="6"
              [min]="0"
              [showButtons]="true"
              [step]="0.0001"
              [disabled]="isSaving()"
              i18n-placeholder="@@modelProperties.price.placeholder"
              placeholder="0.00">
            </p-inputNumber>
          </div>
        </div>
      } @else {
        <p class="empty-hint" i18n="@@modelProperties.price.noPricing">
          No pricing fields apply to this model type.
        </p>
      }
    </section>

    <!-- Раньше здесь была секция Benchmark (auto-run toggle, seed agent picker,
         temperature, system prompt, стартовый диалог). После SKN-290 сама
         конфигурация бенчмарка (эталоны + prompts) живёт на уровне общей
         Benchmark сущности; per-version остаются только is_recommended,
         additional_properties, pricing и M2M-привязки бенчей. -->

    <!-- Bench linking + per-benchmark overrides ушли в отдельный раздел
         /admin/benchmarks. Здесь только properties. -->

    <section class="drawer-section">
      <h3 class="section-title">{{ title }}</h3>
      @if (schemaState() === 'loading') {
        <div class="schema-loading">
          <i class="pi pi-spin pi-spinner"></i>
          <span i18n="@@modelProperties.schema.loading">Загружаем схему версии...</span>
        </div>
      } @else if (schemaState() === 'error') {
        <div class="schema-error">
          <i class="pi pi-exclamation-triangle"></i>
          <span i18n="@@modelProperties.schema.error">Не удалось загрузить схему. Save заблокирован чтобы не перезатереть сохранённые свойства.</span>
          <p-button
            icon="pi pi-refresh"
            severity="secondary"
            [outlined]="true"
            size="small"
            (click)="retryLoadSchema()"
            i18n-label="@@modelProperties.schema.retry"
            label="Повторить">
          </p-button>
        </div>
      } @else {
        <app-openapi-properties-editor
          [properties]="properties()"
          [allowLlmFill]="false"
          [title]="title"
          [showTitleWhenEmpty]="false"
          (propertiesChange)="onPropertiesChange($event)">
        </app-openapi-properties-editor>
      }
    </section>
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        severity="secondary"
        [outlined]="true"
        [disabled]="isSaving()"
        (click)="close()"
        i18n-label="@@common.close"
        label="Close">
      </p-button>
      <p-button
        icon="pi pi-save"
        severity="success"
        [loading]="isSaving()"
        [disabled]="!canSave()"
        (click)="save()"
        i18n-label="@@common.save"
        label="Save">
      </p-button>
    </div>
  </ng-template>
</p-drawer>
